import React from "react";

const OrderHistoryHeader = ({ 
  heading, 
  filters = [],
  className = ""
}) => {
  return (
    <div className={`w-full box-border ${className}`}>
      <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-4 flex-wrap">
        <h1 className="text-xl md:text-2xl lg:text-[32px] font-nonito_sans font-bold text-primary-text">{heading}</h1>
        
        {filters.length > 0 && (
          <div className="flex flex-col md:flex-row items-start md:items-center gap-4 md:gap-6 w-full md:w-auto">
            {filters.map((filter, index) => (
              <div 
                key={index} 
                className={`w-full md:w-auto ${
                  index === 0 ? 'md:flex-grow' : ''
                }`}
              >
                {filter}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default OrderHistoryHeader;